import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import includes from 'lodash/includes'
import AuthActions from '../Redux/AuthRedux'
import AttractionActions from '../Redux/AttractionRedux'
import DbActions from '../Redux/DbRedux'
// import Cookie from 'js-cookie'
import { Sidebar } from '../Components/Nav'
import menus from '../Routes/menus'
import { currentRole, currentBranch } from '../Utils/PrivilegeUtils'

class AppNavigation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      redirect: false,
      refresh: false,
      currency_code: props.preset.setting.currency_code,
      language_code: props.preset.setting.language_code
    }
    this.menus = menus
  }

    componentDidMount = () => {
      this.props.checkLogin()
    }

    _inputChange = (event) => {
      const val = event.target.value
      const name = event.target.name
      let newState = { ...this.state }
      newState[name] = val
      this.setState(newState)
      const { currency_code, language_code } = this.state
      const data = {
        currency_code,
        language_code
      }

      this.props.changePreset(data)
      this.setState({ refresh: true })
    }

    _logout = (e) => {
      if (e) e.preventDefault()
      this.props.logout()
      this.setState({ redirect: true })
    }

    _dbDump = (event) => {
      if (event) event.preventDefault()
      this.props.dbDump()
    }

    _clearCache = (event) => {
      event.preventDefault()
      this.props.clearCache()
    }

    render () {
      // let currentRole = this.props.auth.user ? this.props.auth.user.role : (Cookie.get('user_role') ? Cookie.get('user_role') : '')
      // let currentBranch = this.props.auth.user ? this.props.auth.user.branch_code : (Cookie.get('branch') ? Cookie.get('branch') : '')

      if ((!this.props.auth.user && this.state.redirect) || this.state.redirect) {
        return <Redirect to={'/login'} />
      }

      let grantedAccess = []
      this.menus.map((menu, i) => {
        if (includes(menu.role, currentRole())) {
          grantedAccess.push(menu.url)
          if (menu.subs) {
            menu.subs.map((sub, i) => {
              return grantedAccess.push(sub.url)
            })
          }
        }
        return grantedAccess
      })

      return (
        <main className='app' id='app'>
          <header className='header'>
            <div className='header-block header-block-collapse d-lg-none d-xl-none'>
              <button className='collapse-btn' id='sidebar-collapse-btn'>
                <i className='fa fa-bars' />
              </button>
            </div>
            <div className='header-block header-block-search'>
              {
                currentRole() === 'admin' && currentBranch() !== 'PH' &&
                <Link to='/manage-admin'>
                  <i className='fas fa-users-cog' /> Manage Admin
                </Link>
              }
            </div>
            <div className='header-block header-block-nav'>
              <ul className='nav-profile'>
                {
                  currentRole() === 'admin' &&
                  <li>
                    <a className='nav-link' href='/#' onClick={(e) => this._dbDump(e)}>
                      <i className='fa fa-database icon' /> Export Database
                      {this.props.database.fetching && <span className='badge badge-info ml-2'>Processing...</span>}

                    </a>
                  </li>
                }
                <li>
                  <a className='nav-link' href='/#' onClick={(event) => this._clearCache(event)}>
                    <i className='fa fa-eraser icon' /> Clear Cache
                  </a>
                </li>
                <li className='profile'>
                  <a className='nav-link' href='/#' onClick={(e) => this._logout(e)}>
                    <i className='fa fa-power-off icon' /> Logout
                  </a>
                </li>
              </ul>
            </div>
          </header>
          <Sidebar location={this.props.location} role={currentRole()} menus={this.menus} branch={currentBranch()} />
          <article className='content'>
            {this.props.children}
          </article>
        </main>
      )
    }
}

const stateToProps = (state) => ({
  preset: state.preset,
  auth: state.auth,
  database: state.database
})

const dispatchToProps = (dispatch) => ({
  checkLogin: () => dispatch(AuthActions.authCheckRequest()),
  logout: () => dispatch(AuthActions.authLogout()),
  clearCache: () => dispatch(AttractionActions.attractionClearCacheRequest()),
  dbDump: () => dispatch(DbActions.dbDumpRequest())
})

export default connect(stateToProps, dispatchToProps)(AppNavigation)



// WEBPACK FOOTER //
// ./src/Containers/AppNavigation.js